import store from "@/store";
import { SiteModel } from "@/models/SiteModel";
import FallbackDB from "@/libraries/localStorage";
import { addMagicMethods } from "@/helpers/addMagicMethods";
export class WorkIntervalModel extends SiteModel {
    constructor(id = null) {
        super('work_intervals', +id);
        this._id = +id;
        return addMagicMethods(this);
    }
    async init() {
    }
    getTableData() {
        return store.getters['timer/getDB'] || [];
    }
    setTableData(data) {
        store.commit('timer/setDB', data);
        FallbackDB.save('work_intervals', data);
    }
    static onSuccessSubmit(response) {
        return super.onSuccessSubmit('WorkIntervalModel', response);
    }
    flush() {
        return super.flush('WorkIntervalModel', 'work_intervals');
    }
    __get(target, prop, receiver) {
        let ret;
        switch (prop) {
            default:
                ret = super.__get(target, prop, receiver);
        }
        return ret;
    }
    __set(target, prop, value, receiver) {
        switch (prop) {
            default:
                super.__set(target, prop, value, receiver);
        }
        return true;
    }
}
window.WorkIntervalModel = WorkIntervalModel;
